<template>
  <div class="text-13 h-6 flex items-center">{{ $t('evaluate_editor.crypto-aes-decrypt') }}</div>
</template>

<script>
export default {
  name: 'AESDecryptOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    payload() {
      return this.item.payload;
    },
  },
};
</script>
